export default {
	'menu.welcome': '欢迎',
	'menu.more-blocks': '更多区块',
	'menu.home': '首页',
	'menu.admin': '管理页',
	'menu.admin.sub-page': '二级管理页',
	'menu.system': '系统管理',
	'menu.system.admin-management': '管理员管理',
	'menu.system.login-logs': '登录日志',
	'menu.system.smtp-settings': 'SMTP邮件转发',
	'menu.site': '站点设置',
	'menu.site.website-info': '网站信息',
	'menu.site.menu-management': '菜单管理',
	'menu.site.banner-management': '轮播图管理',
	'menu.content': '内容管理',
	'menu.content.page-management': '页面（模块）管理',
	'menu.content.page-create': '新建页面',
	'menu.content.page-detail': '页面详情',
	'menu.content.page-edit': '编辑页面',
	'menu.content.news-management': '新闻管理',
	'menu.content.news-list': '新闻列表',
	'menu.content.news-create': '新建新闻',
	'menu.content.news-edit': '编辑新闻',
	'menu.content.news-categories': '新闻分类管理',
	'menu.content.article-list': '文章列表',
	'menu.content.article-create': '新建文章',
	'menu.content.article-edit': '编辑文章',
	'menu.content.article-categories': '文章分类管理',
	'menu.content.tag-management': '全站标签管理',
	'menu.content.tag-create': '新建标签',
	'menu.content.tag-edit': '编辑标签',
	'menu.product': '产品管理',
	'menu.product.product-list': '产品列表',
	'menu.product.product-create': '新建产品',
	'menu.product.product-edit': '编辑产品',
	'menu.product.product-edit-alt': '编辑产品',
	'menu.product.product-categories': '产品分类管理',
	'menu.product.product-category-create': '新建分类',
	'menu.product.product-category-edit': '编辑分类',
	'menu.product.product-category-view': '查看分类',
	'menu.product.product-reviews': '产品评论',
	'menu.product.product-review-create': '新建评论',
	'menu.product.product-review-edit': '编辑评论',
	'menu.login': '登录',
	'menu.register': '注册',
	'menu.register-result': '注册结果',
	'menu.dashboard': 'Dashboard',
	'menu.dashboard.analysis': '分析页',
	'menu.dashboard.monitor': '监控页',
	'menu.dashboard.workplace': '工作台',
	'menu.exception.403': '403',
	'menu.exception.404': '404',
	'menu.exception.500': '500',
	'menu.form': '表单页',
	'menu.form.basic-form': '基础表单',
	'menu.form.step-form': '分步表单',
	'menu.form.step-form.info': '分步表单（填写转账信息）',
	'menu.form.step-form.confirm': '分步表单（确认转账信息）',
	'menu.form.step-form.result': '分步表单（完成）',
	'menu.form.advanced-form': '高级表单',
	'menu.list': '列表页',
	'menu.list.table-list': '查询表格',
	'menu.list.basic-list': '标准列表',
	'menu.list.card-list': '卡片列表',
	'menu.list.search-list': '搜索列表',
	'menu.list.search-list.articles': '搜索列表（文章）',
	'menu.list.search-list.projects': '搜索列表（项目）',
	'menu.list.search-list.applications': '搜索列表（应用）',
	'menu.profile': '详情页',
	'menu.profile.basic': '基础详情页',
	'menu.profile.advanced': '高级详情页',
	'menu.result': '结果页',
	'menu.result.success': '成功页',
	'menu.result.fail': '失败页',
	'menu.exception': '异常页',
	'menu.exception.not-permission': '403',
	'menu.exception.not-find': '404',
	'menu.exception.server-error': '500',
	'menu.exception.trigger': '触发错误',
	'menu.account': '个人页',
	'menu.account.center': '个人中心',
	'menu.account.settings': '个人设置',
	'menu.account.trigger': '触发报错',
	'menu.account.logout': '退出登录',
	'menu.editor': '图形编辑器',
	'menu.editor.flow': '流程编辑器',
	'menu.editor.mind': '脑图编辑器',
	'menu.editor.koni': '拓扑编辑器',
	'menu.inquiry': '询盘留言',
	'menu.inquiry.inquiries': '询盘管理',
	'menu.inquiry.messages': '留言管理',
	'menu.inquiry.detail': '详情',
	'menu.inquiry.inquiry-management': '询盘管理',
	'menu.inquiry.message-management': '留言管理',
	'menu.inquiry.subscription-management': '订阅管理',
	'menu.inquiry.inquiry-detail': '询盘详情',
	'menu.inquiry.message-detail': '留言详情',
	'menu.system.audit-logs': '审计日志',
	'menu.content.blocks-management': '全站区块管理'
};
